/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/breakpoint-change';
import './components/offcanvas';
import './components/site-search';
import './components/site-language';
import './components/delay-search-queries';
import { openHtmlPopup } from './components/fancybox';
import './components/footer-menus';
import './components/scroll-to-top';
import './components/gravityforms-loader';
import { initDetailsAnimation } from './components/animate-details';
import { initEqualHeights } from './components/equal-heights';
import { initFilterAccordion } from './components/filter-accordion';

initDetailsAnimation();
initEqualHeights();
if (document.querySelectorAll('[data-filter-accordion]').length > 0) {
	initFilterAccordion();
}
let strlFilterAccordionFwpFirstLoad = true;
document.addEventListener('facetwp-loaded', () => {
	document.querySelectorAll('[data-filter-accordion]').forEach((section) => {
		section.strlFilterAccordionApi?.updateSelectionCounts?.();
	});
	if (!strlFilterAccordionFwpFirstLoad) {
		initFilterAccordion(document.querySelector('.facetwp-template') || document);
	}
	strlFilterAccordionFwpFirstLoad = false;
});
document.addEventListener('open-html-popup', (e) => {
	if (e.detail?.el) openHtmlPopup(e.detail.el, e.detail.opts || {});
});
